(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('MateriaDetailController', MateriaDetailController);

    MateriaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Materia', 'Norma'];

    function MateriaDetailController($scope, $rootScope, $stateParams, previousState, entity, Materia, Norma) {
        var vm = this;

        vm.materia = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:materiaUpdate', function(event, result) {
            vm.materia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
